import { createSlice } from '@reduxjs/toolkit';

import { Plan } from 'entities/Plan';
import { AppError } from 'entities/Errors';

import { getPlans } from './plan.action';

interface PlanState {
  loading: boolean;
  error: null | AppError;
  plans: Plan[];
}

const initialState = {
  loading: false,
  error: null,
  plans: [],
} as PlanState;

export const planSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload.data;
      })
      .addCase(getPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default planSlice.reducer;
